import { FAVOURITES_EVENTS } from '../event_bus_modules/favourites_state';

const addPropertyToFavourites = (element) => {
  const id = element.attr('data-id');
  const csrfToken = element.find('input[name="csrfmiddlewaretoken"]').val();
  EVENT_BUS.dispatch(FAVOURITES_EVENTS.ADD_TO_FAVOURITES, {
    id,
    csrfToken,
  });
};

const removePropertyFromFavourites = (element) => {
  const id = element.attr('data-id');
  const csrfToken = element.find('input[name="csrfmiddlewaretoken"]').val();
  EVENT_BUS.dispatch(FAVOURITES_EVENTS.REMOVE_FROM_FAVOURITES, {
    id,
    csrfToken,
  });
};

$(() => {
  const favouriteButtons = $("[name='favourite-buttons']");
  favouriteButtons.on('click', ($event) => {
    $event.stopPropagation();
    $event.preventDefault();
    const element = $($event.currentTarget);
    const isUserAuthenticated =
      element.attr('data-user-authenticated') === 'True';

    if (isUserAuthenticated) {
      const isAlreadyFavourite = element.hasClass('favourite-active');

      if (!isAlreadyFavourite) {
        addPropertyToFavourites(element);
      } else {
        removePropertyFromFavourites(element);
      }
    } else {
      redirectToLoginPage();
    }
  });

  EVENT_BUS.on(FAVOURITES_EVENTS.ADDED_TO_FAVOURITES, ({ id }) => {
    $(`.favourites[data-id=${id}]`).addClass('favourite-active');
  });

  EVENT_BUS.on(FAVOURITES_EVENTS.REMOVED_FROM_FAVOURITES, ({ id }) => {
    $(`.favourites[data-id=${id}]`).removeClass('favourite-active');
  });
});

const redirectToLoginPage = () => {
  const loginPage = 'login';
  window.location.pathname = loginPage;
};
